import {
  Alert,
  Button,
  FormControl,
  LinearProgress,
  TextField,
} from '@mui/material';
import axios, { AxiosResponse } from 'axios';
import React, { useContext } from 'react';
import { AuthContext } from '../../../contexts/user-context/user-context';
import { OrderType } from '../../../interfaces/delivery-company/orders';
import { BulkActionProps } from './props.interface';
import { ErrorsFlattenner } from '../errors-flattenner/errors-flattenner';
import { isMobile, isTablet } from 'react-device-detect';
import { useSnackBar } from '../../../contexts/snackbar';
import FilterChips from '../filter-chips/filter-chips';
import BulkChangeStateForm from './edit-delivery-state-bulk-form';


function EditDeliveryStateAction({
  selectedOrders,
  bulkEndpoint,
  refetchOrders,
  onFinishAction,
}: BulkActionProps & {  onFinishAction: ()=>void;}) {
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [message, setMessage] = React.useState<string>('');
  const [response, setResponse] = React.useState<AxiosResponse>();
  const [confirmationInput, setConfirmationInput] = React.useState('');
  const targetConfirmation = 'deliver';


  const { user, config } = useContext(AuthContext);
  const orgId = user?.organisation?.org_id;
  const {showMessage} = useSnackBar()

  const handleSubmit = async () => {
    let endpoint = bulkEndpoint;
    if (orgId) {
      endpoint += `?org=${encodeURIComponent(orgId)}`;
    }

    setIsLoading(true);
    setMessage('');
    setResponse(undefined);
    const requestData = Array.from(selectedOrders.keys()).map((order_pk) => {
      const order = {
        id: order_pk,
      };
      return order;
    });

    try {
      const response = await axios.delete<OrderType[]>(endpoint, {
        ...config,
        data: requestData,
      });
      setResponse(response);
      showMessage('Marked as Delivered')
      setMessage('Orders cancelled successfully');
      refetchOrders();
    } catch (e) {
      showMessage('Something went wrong', 'error')
      if (axios.isAxiosError(e)) {
        setResponse(e.response);
        setMessage('Failed to cancel orders: ' + e.response?.statusText);
      } else {
        setMessage('Failed to cancel orders');
      }
    }
    setIsLoading(false);
  };

  console.log(response);

  return <BulkChangeStateForm orders={Array.from(selectedOrders.values())} onSuccess={()=>{refetchOrders(); onFinishAction();}} />
}

export default EditDeliveryStateAction;
